import { h, type FunctionalComponent } from '@stencil/core';
import { ConversationalSearchLabelWithSection } from '../../conversational-search-partials/label-with-section/label-with-section';
import type { labelProviderInterface } from '../../../../LabelProviderInterface';

export const ConversationalSearchBannerLarge: FunctionalComponent<{
  labelProvider: labelProviderInterface;
  callback: () => void;
  term: string;
  ctaText: string;
  tagText: string;
}> = (props) => {
    const text = props.labelProvider(
      'conversational.search.banner.large.content',
      'Take your search experience to the next level with the support of our {0}.',
    );

    const coloredPart = props.labelProvider(
      'conversational.search.banner.large.hightlight',
      'AI-powered search tool',
    );

    const listElements = [
      props.labelProvider(
        'conversational.search.banner.explanations.first',
        'Ask a question and find the right results faster than ever before.',
      ),
      props.labelProvider(
        'conversational.search.banner.explanations.second',
        'Define your search need with use of descriptive words.',
      ),
      props.labelProvider(
        'conversational.search.banner.explanations.third',
        'Engage GenAI in a conversational mode and narrow down the suggestions.',
      ),
    ];

    return (
      <div class="conversational-search-large-banner">
        <qds-tag color="green" status="success" text={props.tagText} />
        <div class="conversational-search-large-banner__title">
          <ConversationalSearchLabelWithSection
            text={text}
            partial={coloredPart}
            isNonBoldedGreen={true}
          />
        </div>
        <ul>
          {listElements.map((item) => (
            <li>{item}</li>
          ))}
        </ul>
        <qds-button
          size="large"
          importance="emphasized"
          onClick={() => props.callback()}
          text={props.ctaText}
        ></qds-button>
      </div>
    );
};
